import { useAuth as t } from "@phx-husky/use-auth";
var r = function r() {
  var r = t();
  return {
    translate: function translate(t, s) {
      for (var _len = arguments.length, a = new Array(_len > 2 ? _len - 2 : 0), _key = 2; _key < _len; _key++) {
        a[_key - 2] = arguments[_key];
      }
      return r.translate.apply(r, [t, s].concat(a));
    }
  };
};
export { r as useTranslations };